<template>
  <div class="no-data-wrap">
    <img src="@/assets/images/nodata.png" alt="icon" />
    <div class="info">{{ info }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    info: {
      type: String,
      default() {
        return "暂无数据";
      },
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
.no-data-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    display: block;
    width: 150px;
    height: 150px;
    margin-bottom: 10px;
  }
  .info {
    height: 19px;
    font-size: 14px;
    color: #999999;
    line-height: 19px;
  }
}
</style>
